export const ProgressiveLabsCoreEnrollmentArray = ["Health Plan"];
